
<script setup>
import { onBeforeMount, inject } from 'vue';
import { getAuth} from "firebase/auth";
import { initializeApp } from 'firebase/app';
import { removeAuth  } from '@/core/modules';

import { useRouter } from 'vue-router';
const firebaseConfig = inject('firebaseConfig')

onBeforeMount(() =>{
    logout();
    const router = useRouter();
    router.push({ path: '/' });
});

const logout = () => {
    const app = initializeApp(firebaseConfig);
    const auth = getAuth(app);
    auth.signOut();
    removeAuth();
}
</script>